import React from 'react'

function Boresha2() {
  return (
    <div>

<div className="my-4">
        <ul className="list-disc list-inside">

        <li>The Plan offers high savings returns; which is a higher return compared to other average education insurance products in the market.</li>
        <li>Guaranteed Bonus Payouts; this is the main benefit of this product. The Boresha Elimu Plan pays three guaranteed lump sum payments in the last three years of the plan, equivalent to the sum assured.</li>
        <li>Optional Lump Sum Death Cover; There is an optional death benefit, which pays the principal sum in the event of the untimely death of the assured life before maturity.</li>
        <li>Surrender Benefits; A surrender benefit is payable and may be accessed from the end of 25th policy month.</li>
        </ul>
      </div>



    </div>
  )
}

export default Boresha2